import { useGlobalStore } from './global';
import { useGameStore } from './game';
import { useAudioStore } from './audio';
import { useStatsStore } from './stats';
import { useAchievmentStore } from './achievements';
import { useThemeStore } from './theme';
import { useTutorialStore } from './tutorial';

const useModule = () => {
    return {
        global: useGlobalStore(),
        game: useGameStore(),
        tutorial: useTutorialStore(),
        audio: useAudioStore(),
        stats: useStatsStore(),
        theme: useThemeStore(),
        achievements: useAchievmentStore()
    }
}

export {
    useModule
}